/**
 * Whether these props belong to a control that opens a popup — a menu, select, combobox or popover
 * trigger. A trigger rendered through `asChild` gets the popup's ARIA props, so `aria-haspopup` is
 * the control's own signal.
 *
 * Not `!!value`: React renders `aria-*` booleans as strings rather than dropping them, so an
 * explicit `aria-haspopup={false}` arrives here as `false` and leaves as `"false"` — both mean no.
 */
const opensPopup = (props: { 'aria-haspopup'?: boolean | string }): boolean => {
  const value = props['aria-haspopup'];
  return value !== undefined && value !== false && value !== 'false';
};

export default opensPopup;
